<template>
  <div class="mb-3">
    <h2 class="fw-light d-flex align-items-center mb-0">
      <router-link
        to="/home"
        class="d-flex align-items-center me-2"
        title="Voltar"
      >
        <i class="ph-caret-circle-left ph-2x" />
      </router-link>
      Certidões dos Fornecedores
    </h2>
  </div>
  <LoadingData v-if="isLoading" />
  <DataTableDefault
    v-else
    :dataTable="dataTable"
    :options="optionsDataTable"
    customClass="table-xs fs-sm"
  />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import DataTableDefault from '@/components/commons/DataTableDefault.vue'
import { removeCnpjCharacteres } from '@/utils/strings'

export default {
  name: 'SuppliersList',

  components: {
    LoadingData,
    DataTableDefault,
  },

  data() {
    return {
      isLoading: true,
      dataTable: {
        columns: [
          {
            data: 'supplierDocument',
            title: 'CNPJ',
          },
          {
            data: 'supplierName',
            title: 'Nome',
          },
          {
            data: 'link',
            title: 'Ações',
            searchable: false,
            orderable: false,
            render(value) {
              return `
              <a href="#" data-item-router="/documents/suppliers" data-item-id="${removeCnpjCharacteres(
                value,
              )}" class="badge bg-primary" title="Detalhar">
                Detalhar
              </a>`
            },
          },
        ],
        data: [],
      },
      optionsDataTable: {
        pageLength: 25,
        order: [[1, 'asc']],
        columnDefs: [{ targets: [2], className: 'text-center' }],
      },
    }
  },

  methods: {
    async getSuppliers() {
      try {
        const suppliers = await this.$store.dispatch('getSuppliers')

        this.dataTable.data = suppliers.map((supplier) => {
          return {
            supplierDocument: supplier.supplierDocument,
            supplierName: supplier.supplierName,
            link: supplier.supplierDocument,
          }
        })

        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getSuppliers()
  },
}
</script>
